module.exports = __webpack_public_path__ + "static/img/qr-LUCI-Android.9bc18f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/qr-LUCI-Android.png
// module id = 5DQh
// module chunks = 3